import { flatTypes } from './common';

export const flatTypesColorsMap = new Map([
  [flatTypes.office, '#881bb3'],
]);
